import { metricKeys } from '@pulse/metrics';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';

const SPI_METRIC_LIST = {
  EI: metricKeys.StreamingPerformanceIndex,
  APP: metricKeys.AppServicePerformanceIndex,
  AI: null,
};

const SESSIONS_METRICS_LIST = {
  EI: [
    metricKeys.GoodSession,
    metricKeys.GoodSessionAverageLifePlayingTimeMins,
    metricKeys.BadSession,
    metricKeys.BadSessionAverageLifePlayingTimeMins,
    metricKeys.BadSessionPct,
  ],
  AI: [],
  APP: [
    metricKeys.AppSPIGoodSession,
    metricKeys.AppSPIImpactedSession,
    metricKeys.AppSPIImpactedSessionRate,
  ],
  ODP: [],
};

const SESSION_WIDGET_CONFIG_LIST = {
  EI: {
    good: metricKeys.GoodSession,
    goodSecondary: metricKeys.GoodSessionAverageLifePlayingTimeMins,
    bad: metricKeys.BadSession,
    badSecondary: metricKeys.BadSessionAverageLifePlayingTimeMins,
    badRate: metricKeys.BadSessionPct,
  },
  AI: {},
  APP: {
    good: metricKeys.AppSPIGoodSession,
    goodSecondary: null,
    bad: metricKeys.AppSPIImpactedSession,
    badSecondary: null,
    badRate: metricKeys.AppSPIImpactedSessionRate,
  },
  ODP: {},
};

export const SPI_LABEL =
  {
    EI: 'SPI',
    APP: 'QoE',
    AI: '',
    ODP: '',
  }[CURRENT_PRODUCT_MODE] || '';

export const SESSIONS_METRICS = SESSIONS_METRICS_LIST[CURRENT_PRODUCT_MODE];
export const SPI_METRIC = SPI_METRIC_LIST[CURRENT_PRODUCT_MODE];
export const SESSION_WIDGET_CONFIG = SESSION_WIDGET_CONFIG_LIST[CURRENT_PRODUCT_MODE];

export const THRESHOLD_SERVICE_STATUS_TEXT = `Showing Conviva Good since custom KPIs are not available right now.`;
